An array of identifiers for the `HiringOrganization`s that have the position.
